import Axios from 'axios';
import { batch } from 'react-redux';

import { accountIdSelector } from 'store/user/selectors';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';
import { decamelizeKeys } from 'utils/humps';

import { update, load, setSearchResultCountersAction } from './index';

const decoratedAxiosGet = axiosGetAutoCancelDecorator();
export const fetchThunk =
  ({ content, ...queryParams }) =>
  async (dispatch, getState) => {
    const accountId = accountIdSelector(getState());
    dispatch(load(true));

    try {
      const response = await decoratedAxiosGet(`/acc/${accountId}/properties/${content}`, {
        params: decamelizeKeys(queryParams),
      });

      batch(() => {
        dispatch(load(false));
        dispatch(update(response.data));
      });
    } catch (err) {
      dispatch(load(false));

      if (!(err instanceof Axios.Cancel)) {
        throw err;
      }
    }
  };

const decoratedAxiosGetCounters = axiosGetAutoCancelDecorator();
export const getResourceLibrarySearchCountersThunk = (q) => async (dispatch, getStore) => {
  const accountId = accountIdSelector(getStore());

  try {
    const response = await decoratedAxiosGetCounters(`/acc/${accountId}/properties/search_counters`, {
      params: { q },
    });

    dispatch(setSearchResultCountersAction(decamelizeKeys(response.data)));
  } catch (err) {
    if (!(err instanceof Axios.Cancel)) {
      throw err;
    }
  }
};
